module.exports = new __parcel__URL__("staging.daa5274a.svg").toString();